<script>
import { onMount } from "svelte";
import {songDirectory} from "./song-directory.js";
import SongCollectionObject from "./SongCollectionObject.svelte";
import Icon from "./Icon.svelte";
import ExternalSearchbar from "./ExternalSearchbar.svelte";

let searchTerm = "(placeholder...)";
let songSelected = "容我寧靜";
let youtubeEmbedUrls = [
	"https://www.youtube.com/embed/eEqv5FOvv5g", 
	"https://www.youtube.com/embed/eEqv5FOvv5g"
];

// on searchTerm entered, filter lists
function filterSongList(searchTerm) {

	// open/collapse song punlisher/albums
	if (searchTerm === "") {
		document.querySelectorAll("details").forEach(element => element.removeAttribute("open"));
	} else {
		document.querySelectorAll("details").forEach(element => element.setAttribute("open", ""));
	}

	// clear previous matches
	document.querySelectorAll(".hasMatch").forEach(element => {
		element.classList.remove("hasMatch");
	});

	// show current matches
	document.querySelectorAll(".song").forEach(element => {
		if (element.textContent.toLowerCase().includes(searchTerm.toLowerCase())) {
			//all parents li hasMatch
			let ancestor = element.parentElement;
			while (ancestor) {
				if (ancestor.tagName == "LI") {
					ancestor.classList.add("hasMatch");
				}
				ancestor = ancestor.parentElement;
			}
		}
	});
}

// on song selected, search youtube for videos
$: {
	songSelected = songSelected.replace(/^\d+.\s*/, ""); // remove leading numbering
	searchYoutube(songSelected);
}
function searchYoutube(songSelected) {
	console.log(songSelected); // DEBUG
	fetch("https://youtube-scrape.jest.one/api/search?q=" + songSelected)
		.then(response => response.json())
		.then(searchResult => searchResult.results)
		.then((searchResults) => {
			for (let i = 0; (i < youtubeEmbedUrls.length) && (i < searchResults.length); i++) {
				if (searchResults[i].hasOwnProperty("video")) {
					youtubeEmbedUrls[i] = "https://www.youtube.com/embed/" + searchResults[i].video.id;
				}
			}
		});
}

onMount(() => {
	filterSongList(""); // trigger searchTerm-changed callback, to display all songs at first
});

</script>

<header class="navbar">
	<h1 class="title">詩歌目錄</h1>
	<div class="searchbar song_searchbar">
		<input type="search" on:input={event => filterSongList(event.target.value)} placeholder="搜尋..." />
		<div class="icon"><Icon icon="search"/></div>
	</div>
</header>
<div class="row">
	<div class="sidebar col-6">
		<SongCollectionObject songCollectionObject={songDirectory} bind:songSelected />
	</div>
	<div class="content col-6">
		<h2>{songSelected}</h2>
		<hr>
		{#each youtubeEmbedUrls as src, i}
			<div class="youtube-video-container">
				<div class="aspect-ratio-16-9">
					<iframe {src} title="Youtube Search Result {i+1}" allowfullscreen></iframe>
				</div>
			</div>
		{/each}
		<div class="footnote">
			(以上Youtube乃電腦自動產生，有時會不準確。)
		</div>

		<div class="external-searchbar">
			<ExternalSearchbar site="google" searchTerm={songSelected} searchSuffixes={["歌詞", "譜"]} />
		</div>
		<div class="external-searchbar">
			<ExternalSearchbar site="youtube" searchTerm={songSelected} />
		</div>

	</div>
</div>

<style>
	.external-searchbar {
		margin-bottom: 1rem;
	}
</style>